
export class Thermo {
	keycode: string;
	devcode: string;
	Description: string;
	ProductTypeId: number;
	current_season: string;
	mode: string;
	temp_loc: number;
	manual_temp: number;
	hum_loc: number;
	set_mode: string;
	set_manual_temp: number;
	on_line: number;
	relay_status: number;
	error: string;
	signal_level: string;
	bb?: ThermoBnB;
	qe?: ThermoQnE;
	"Global FW Version"?: string;
}

export class ThermoBnB {
	enable: boolean;
	delta_temp_p: number;
	delta_temp_n: number;
	temp: number;

	constructor() {
		this.enable = false;
		this.delta_temp_p = 1;
		this.delta_temp_n = 1;
		this.temp = 20;
	}
}

export class ThermoQnE {
	enable: boolean;
	stdby_temp: number;
	courtesy_time: number;
	permission_status: boolean;

	constructor() {
		this.enable = false;
		this.stdby_temp = 20;
		this.courtesy_time = 30;
		this.permission_status = false;
	}
}

export class DevicesThermo {
	system: boolean;
	user: string;
	name: string;
	items: Thermo[];
}

export class ThermoLog {
	Keycode: string;
	IntervalType: string;
	From: number;
	To: number;
	PowerOnTime: ThermoStats;
	Humidity: ThermoStats;
	SetPoint: ThermoStats;
	InternalTemperature: ThermoStats;
	ExternalTemperature: ThermoStats;
	ConnectionEvents: ThermoStats;
}

export class ThermoStats {
	Average: number;
	List: ThermoStatsValue[];
}

export class ThermoStatsValue {
	Timestamp: number;
	Value: string;
}

export class ThermoGroupInvitation {
	email: string;
	firstName: string;
	lastName: string;
	groupId: number;
}